import { render, staticRenderFns } from "./RecoveryCodes.vue?vue&type=template&id=50c49c62"
import script from "./RecoveryCodes.vue?vue&type=script&lang=js"
export * from "./RecoveryCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports